import React from 'react';
import { Typography } from '../../ui-kit';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import './ConfirmModalMassUpdateProduct.scss';

const ConfirmModalMassUpdateProduct = ({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <ConfirmModal
    className="ConfirmPropagateModal"
    visible={isOpen}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmText="Continue"
    cancelText="Cancel"
    confirmBtnType="primary"
    destroyOnClose
  >
    <Typography className="ConfirmPropagateModal_title" variant="h6">
      Update Tile in All Stores
    </Typography>
    <p>
      This will update and copy ALL details and settings from this tile to every tile with the same
      name, across all stores.
    </p>
  </ConfirmModal>
);

export default ConfirmModalMassUpdateProduct;
